export default __webpack_public_path__ + "static/media/download.0433b356.svg";